






























































































































































































































































































































































































































































































import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component
export default class GuiaTissSadt extends Vue {
  @Prop({ default: '' }) doctorSignature: string

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get parsedSurgerySolicitationData() {
    return {
      patient: {
        name: this.surgerySolicitationData.paciente.nome,
        healthInsuranceId: this.surgerySolicitationData.paciente.carteirinha,
        healthInsurancePlanName: this.surgerySolicitationData.paciente.planoNome,
      },
      hospital: {
        cnpj: this.surgerySolicitationData.cnpjDoHospital,
        name: this.surgerySolicitationData.hospital && this.surgerySolicitationData.hospital.nome,
      },
      doctor: {
        name: this.surgerySolicitationData.medicoSolicitante.nome,
        state: this.surgerySolicitationData.medicoSolicitante.conselhoUf,
        document: `${this.surgerySolicitationData.medicoSolicitante.conselhoTipo} ${this.surgerySolicitationData.medicoSolicitante.conselhoNumero}-${this.surgerySolicitationData.medicoSolicitante.conselhoUf}`,
        specialty: this.surgerySolicitationData.medicoSolicitante.especialidade,
      },
      surgeryInfo: {
        signAndSentDate: this.formatDate(this.surgerySolicitationData.dataEnvio),
        cid: this.CID,
        nature: this.surgeryNature,
        procedures: this.procedures,
        justificationDiagnosis: this.surgerySolicitationData.diagnosticoJustificativa,
      },
    }
  }

  get surgerySolicitationData() {
    return this.getBackofficeGlobalStore.solicitacao
  }

  get CID() {
    return this.surgerySolicitationData.cids && this.surgerySolicitationData.cids.map(
      cid => ((cid.codigo && cid.descricao) ? `${cid.codigo}-${cid.descricao}` : '-'),
    ).join(', ')
  }

  get surgeryNature() {
    const { carater: surgeryNature } = this.surgerySolicitationData

    if (surgeryNature && typeof surgeryNature !== 'number' && surgeryNature.key === 'EletivoAutorizacao') {
      return 'E'
    }

    if (surgeryNature && typeof surgeryNature !== 'number' && (surgeryNature.key === 'Urgencia' || surgeryNature.key === 'Emergencia')) {
      return 'U'
    }

    return '|__|'
  }

  get procedures() {
    const { procedimento: mainProcedure } = this.surgerySolicitationData
    const associatedProcedures = this.surgerySolicitationData.procedimentosAssociados || []

    const allProcedures = [mainProcedure, ...associatedProcedures]

    return allProcedures.map(procedure => ({
      authorizedQuantity: (procedure && procedure.quantidadeAutorizada) || null,
      quantity: (procedure && procedure.quantidade) || null,
      code: (procedure && procedure.codigo) || null,
      description: (procedure && procedure.descricao) || null,
    }))
  }

  formatDate(dateString) {
    const date = new Date(dateString)

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  }
}
